import { bigIntToLong } from '#common/util';
import { FetchKeysMsg, KeyRangeMsg, MetaStoreRequestMsg, ServiceBaseProto, } from '#websocket/client/proto';
import { META_STORE_REQUEST_TYPE, META_STORE_RESPONSE_TYPE } from './types';
export class FetchDataRequest {
    rangeStart;
    rangeLimit;
    maxKeys;
    maxSize;
    destination;
    cursor;
    constructor(rangeStart, rangeLimit, maxKeys, maxSize, destination, cursor) {
        this.rangeStart = rangeStart;
        this.rangeLimit = rangeLimit;
        this.maxKeys = maxKeys;
        this.maxSize = maxSize;
        this.destination = destination;
        this.cursor = cursor;
    }
    createMessage(requestId, version) {
        const range = KeyRangeMsg.create({
            start: this.rangeStart,
            limit: this.rangeLimit,
        });
        const fetchDataMessage = FetchKeysMsg.create({
            range,
            maxSize: bigIntToLong(this.maxSize),
            maxKeys: bigIntToLong(this.maxKeys),
            cursor: this.cursor ? this.cursor : null, // eslint-disable-line no-restricted-syntax -- Communicating with protobuf interface.
        });
        const metaStoreRequest = MetaStoreRequestMsg.create({
            type: MetaStoreRequestMsg.RequestType.FETCH_DATA_REQUEST,
            fetch: fetchDataMessage,
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [META_STORE_REQUEST_TYPE]: metaStoreRequest,
        });
    }
    createResponse(responseMessage) {
        return new FetchDataResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
export class FetchDataResponse {
    result;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        this.result = responseMsgObject[META_STORE_RESPONSE_TYPE].fetch;
    }
}
